document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver((mutations, obs) => {
    let trigger = document.querySelector('.viralsweep_trigger');
    if (trigger) {
      const lightboxTrigger = viralsweep_lightbox_204552;
      let triggerBtnList = [".referral-banner .btn", ".btn-popup"];
      triggerBtnList?.forEach((itemSelector) => {
        let triggerBtn = $(itemSelector);
        if(triggerBtn.length) {
          triggerBtn.attr("href", "javascript:void(0);");
          triggerBtn.attr("target", "_self");
          $(document).on("click", itemSelector, function(e) {
            e.preventDefault();
            e.stopPropagation();
            lightboxTrigger.lightbox_on();
          });
        }
      });
      obs.disconnect(); // 停止监听
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
});